import type { FaireProductEntity } from "../../entity_types/product";

export const p_n6wq9aeexg: FaireProductEntity = {
  token: "p_n6wq9aeexg",
  type: "product",
  name: "Halloween Ghost Kids Bamboo Pajama Set, Soft Two-Piece PJs",
  brandToken: "b_zfwjzfkx9f",
  brandName: "Itsy Bitsy Boutique",
  imageUrl:
    "https://cdn.faire.com/fastly/01ccb4175732bd70fa0eae55f1c746e0a622b4a774aa19f5cf250490b8841bbe.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/091cf0d8fa01102cec3868f975da717d2336ba2bfa184c2bc50f12fe2b371be3.png",
    "https://cdn.faire.com/fastly/ba656cbfbca5bfec2f4d91d5c9456b0eb3fad3e523f9c0da536183d09ffc99be.png",
    "https://cdn.faire.com/fastly/b0282627b3941b90b585c3986da609e619217f1dc9b27ef2a85d711b1208cdf2.png",
    "https://cdn.faire.com/fastly/dd7c6fed448b30d04d2ec8bed3b5a7559387bc9e1a3298ca5d225683c7406c9a.png",
    "https://cdn.faire.com/fastly/60dde59ed28e6cf994fda66192e070438eed14a7c13e7c6f63e1374de9da6f80.png",
    "https://cdn.faire.com/fastly/115b6704e461848e3ddf0cd958cb6f587bf21e4c54c72c2d8e7ff08e3cc10b3b.png",
    "https://cdn.faire.com/fastly/3cb9aeec15ddd845d633ae13e24bbbbab2d0bc90c4e1b869d667e82560dacd8a.png",
    "https://cdn.faire.com/fastly/d219c44c3f7b6c196f043cd656a7ef72633a499df41476bb8ebdbf0463ccb947.png",
  ],
  priceDollars: 17.47,
  description:
    "A premium viscose-from-bamboo sleepwear essential designed for softness, stretch, and extended wear. Modern prints parents love—and come back for.\n\n✨ FEATURES \n\t• Ultra-soft viscose from bamboo (gentle on sensitive skin)\n\t• Breathable + temperature regulating\n\t• Long, stretchy fit designed to last multiple growth stages\n\t• Snug-fitting design for sleepwear compliance\n\t• Durable through repeated washing\n\n💼 WHY RETAILERS LOVE THIS \n\t• High repeat purchase product (parents return for new sizes + prints)\n\t• Premium feel → strong perceived retail value\n\t• Neutral + on-trend designs = easy sell-through\n\t• Strong gifting category (baby showers, birthdays)\n\t• Flexible sizing reduces return risk\n\n📏 FIT & SIZING\n\t• True to size with a long, stretchy fit\n\t• Designed to fit longer than traditional cotton sleepwear\n\t• No need to size up\n\n🧵 FABRIC\n\t• 95% viscose from bamboo, 5% spandex\n\n🏷️ PRODUCT DETAILS\n\t• Style: Two-Piece Set\n\t• Pattern:  Midnight Mischief\n\t• Sizes: 2T - 7/8\n\t• Designed in Canada",
  tags: [],
  msrpDollars: 34.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:47.837Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
